import Component from "flarum/Component";
import Link from "flarum/components/Link";
import avatar from "flarum/helpers/avatar";
import username from "flarum/helpers/username";
import app from 'flarum/common/app';

export default class PointsLeaderboardListItem extends Component {
    view() {
        const { leaderboardListItem, rankID } = this.attrs;
        const pointsName = app.forum.attribute('tf-points.pointsname') || '[points]';
        const pointsValue = leaderboardListItem.data?.attributes?.points || leaderboardListItem.attributes?.points || 0;
        const pointsText = pointsValue;
        let trophyClass = "PointsLeaderboardListItemTrophyNone";
        let rankClass = "PointsLeaderboardListItemRankTop";

        if (rankID === 1) {
            trophyClass = "PointsLeaderboardListItemTrophyGold";
        } else if (rankID === 2) {
            trophyClass = "PointsLeaderboardListItemTrophySilver";
        } else if (rankID === 3) {
            trophyClass = "PointsLeaderboardListItemTrophyBronze";
        } else {
            rankClass = "PointsLeaderboardListItemRankLower";
        }

        return (
            <div className="PointsLeaderboardListItemContainer">
                <div class="PointsLeaderboardListHeaderRank">
                    <div class={rankClass}>{rankID}</div>
                    <div class={trophyClass}>
                        <i class="fa-light fa-trophy"></i>
                    </div>
                </div>
                <div class="PointsLeaderboardListHeaderUser">
                    {leaderboardListItem && leaderboardListItem.id ? (
                        <Link href={`/u/${leaderboardListItem.attributes.username}`} className="transferHistoryUser" style="color:var(--heading-color)">
                            {leaderboardListItem.attributes.displayName || leaderboardListItem.attributes.username}
                        </Link>
                    ) : (
                        <span className="transferHistoryUser" style="color:var(--heading-color)">
                            {leaderboardListItem.attributes.displayName || leaderboardListItem.attributes.username}
                        </span>
                    )}
                </div>
                <div class="PointsLeaderboardListHeaderPoints">
                    {pointsText}
                </div>
            </div>
        );
    }
}
